import { render } from "./AndroidWaitlist.vue?vue&type=template&id=916cbf54&scoped=true"
import script from "./AndroidWaitlist.vue?vue&type=script&lang=js"
export * from "./AndroidWaitlist.vue?vue&type=script&lang=js"

import "./AndroidWaitlist.vue?vue&type=style&index=0&id=916cbf54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-916cbf54"]])

export default __exports__